import * as React from 'react'

import { cn } from '@/utilities/ui'

function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      className={cn('animate-pulse rounded-md bg-black/10', className)}
      {...props}
    />
  )
}

export { Skeleton }
